<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <SectionTitle :title="label('title')"/>
      </v-col>
    </v-row>
    <v-row id="academicHistory">
      <FormItem :name="label('education')" required>
        <SelectField
                v-model="education"
                :name="label('education')"
                :items="educations"
                required
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="schoolName">
      <FormItem :name="label('school')" required>
        <TextField
                v-model="school"
                :name="label('school')"
                required
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="department">
      <FormItem :name="label('faculty')" required>
        <TextField
                v-model="faculty"
                :name="label('faculty')"
                required
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem :name="label('subject')">
        <TextField
                v-model="subject"
                :name="label('subject')"
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="graduated">
      <FormItem :name="label('enrollment')" required no-margin-bottom>
        <RadioField
                v-model="enrollment"
                :name="label('enrollment')"
                row
                :items="enrollments"
                required
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="graduatedYear">
      <FormItem :name="label('graduatedYear')" :required="requiredGraduatedYear">
        <SelectField
                v-model="graduatedYear"
                :name="label('graduatedYear')"
                :items="years"
                :disabled="disabledGraduatedYear"
                :required="requiredGraduatedYear"
                :submit="submit"
        />
      </FormItem>
    </v-row>
  </v-container>
</template>

<script>
  import SectionTitle from "../atoms/SectionTitle";
  import SelectField from "../atoms/SelectField";
  import FormItem from "../molecules/FormItem";
  import TextField from "../atoms/TextField";
  import RadioField from "../atoms/RadioField";
  import ComponentMixin from "../ComponentMixin";
  import {mapGetters} from "vuex";
  import moment from "moment";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "EducationForm",
    props: {
      "value": {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      education: {
        get () {
          return this.value.academicHistory
        },
        set (value) {
          this.$emit("input", {...this.value, academicHistory: value})
        }
      },
      enrollment: {
        get () {
          if (this.value.graduated) {
            return {select: this.value.graduated};
          }
          return null;
        },
        set (value) {
          if (value === 1) {
            this.value.graduatedYear = null;
            this.$emit("input", {...this.value, graduated: value.select})
          } else {
            this.$emit("input", {...this.value, graduated: value.select, graduatedYear: null})
          }
        }
      },
      school: {
        get () {
          return this.value.schoolName
        },
        set (value) {
          this.$emit("input", {...this.value, schoolName: value})
        }
      },
      faculty: {
        get () {
          return this.value.department
        },
        set (value) {
          this.$emit("input", {...this.value, department: value})
        }
      },
      subject: {
        get () {
          return this.value.departmentDetail
        },
        set (value) {
          this.$emit("input", {...this.value, departmentDetail: value})
        }
      },
      graduatedYear: {
        get () {
          return this.value.graduatedYear
        },
        set (value) {
          this.$emit("input", {...this.value, graduatedYear: value})
        }
      },
      educations () {
        return this.consts.academics;
      },
      enrollments () {
        return this.consts.isGraduated;
      },
      years () {
        const years = [];
        const currentYear = moment().year();
        for (let year = currentYear; year >= 1900; year--) {
          years.push({label: year, value: year})
        }
        return years;
      },
      disabledGraduatedYear () {
        return this.value.graduated === 1;
      },
      requiredGraduatedYear () {
        return this.value.graduated === 2;
      }
    },
    methods: {
      submit () {
      }
    },
    components: {
      SectionTitle,
      FormItem,
      SelectField,
      TextField,
      RadioField
    }
  }
</script>

<style scoped>

</style>
